module.exports = __webpack_public_path__ + "img/a29.5967b058.svg";